<template>
  <Timestamp :date="conversation.creationDate" />
  <Info class="my-24" :conversation />

  <div class="space-y-24">
    <Message
      v-for="message in conversation.messages"
      :key="message.messageId"
      :message
    />
  </div>
</template>

<script setup lang="ts">
import type { Conversation } from '~/api/seller-after-sales/types'

import Info from './components/Info/Info.vue'
import Message from './components/Message/Message.vue'
import Timestamp from './components/Timestamp.vue'

defineProps<{
  conversation: Conversation
}>()
</script>
